import {
	is, getType, debounce, throttle, timeout, sleep
} from './helpers/base'

import {
	dataNode, dataSelector
} from './helpers/jq'

import {
	globalCall,
	colors
} from './modules/globalCall'

import {
	ajax, asyncAjax, ajaxSubmitInner, ajaxSubmit,
	ajaxDelegate, ajaxCaptchaRequest, ajaxCaptcha
} from './modules/ajax'

import privacyControl from './modules/privacyControl'

import {
	inputJut, fileInput, inputThumb, formSearchFilter, formInvalidScroll
} from './modules/inputsForms'

import product from './modules/product'
import slick   from './modules/slick'

import { datepicker, datepickerRun } from './modules/datepicker'
import { bootstrapMultiselect, dropzone, hashTrigger } from './modules/pageCall'
import { ckeditor, geogebra, wirisEditor } from './modules/editor'



const $_GP = window.$_GP || {};
$_GP.fn  = $_GP.fn || {};
$_GP._ = $_GP._ || {};

$_GP.REQUEST_ACTIVE = false

$_GP._.is = is
$_GP._.getType = getType
$_GP._.throttle = throttle
// $_GP._.debounce = debounce
$_GP._.timeout = timeout
$_GP._.sleep = sleep

// $_GP.dataNode = dataNode
dataSelector()
globalCall()
inputJut()

$_GP.colors             = colors()
$_GP.ajax               = ajax
$_GP.asyncAjax          = asyncAjax
$_GP.ajaxSubmitInner    = ajaxSubmitInner
$_GP.ajaxSubmit         = ajaxSubmit
$_GP.ajaxDelegate       = ajaxDelegate()
$_GP.ajaxCaptchaRequest = ajaxCaptchaRequest
$_GP.ajaxCaptcha        = ajaxCaptcha
$_GP.privacyControl     = privacyControl()

// $_GP.fileInput          = fileInput()
$_GP.inputThumb         = inputThumb()
// $_GP.formSearchFilter   = formSearchFilter
$_GP.formInvalidScroll  = formInvalidScroll
// $_GP.product            = product()

$_GP.fn.datepicker      = datepicker
datepickerRun()
$_GP.fn.bootstrapMultiselect = bootstrapMultiselect()
$_GP.fn.dropzone             = dropzone()
$_GP.fn.hashTrigger          = hashTrigger
// $_GP.fn.slick           = slick()

$_GP.ckeditor             = ckeditor()
$_GP.geogebra             = geogebra()
$_GP.wirisEditor          = wirisEditor()

